import { isEmpty } from 'lodash';
export const customers = (state) => state.customers;
export const hasCustomers = (state) => !isEmpty(state.customers);
export const isUserCustomer = (state) =>
  !isEmpty(state.customers) ? state.customers.some((customer) => customer.isCustomerUser) : false;
export const customerUser = (state) => {
  if (state.customerUserDetails) return state.customerUserDetails;
  return !isEmpty(state.customers) && state.customers.some((customer) => customer.isCustomerUser)
    ? state.customers.filter((customer) => customer.isCustomerUser)[0]
    : undefined;
};
export const isLoadingCustomers = (state) => state.isLoadingCustomers;
